import { For, Grid, GridItem } from '@chakra-ui/react';
import Player from '@components/common/video/Player';
import { computePlayerStreamUrl } from '@utils/sensors/camera/camera.utils';
import { memo } from 'react';

import { PerimeterCamera } from '@/types/sensor/sensors/perimeterCamera.types';

import PerimeterCameraWrapper from './PerimeterCameraWrapper';
import { PerimeterGridProps } from './PerimeterGrid';

interface CamGridProps extends PerimeterGridProps {
  cameras: PerimeterCamera[];
  onPlayerDoubleClick: () => void;
}

function CamGrid({ innerGridHeight, innerGridWidth, uniqueKey, cameras, onPlayerDoubleClick }: Readonly<CamGridProps>) {
  return (
    <Grid
      templateColumns={`repeat(${innerGridWidth}, 1fr)`}
      templateRows={`repeat(${innerGridHeight}, 1fr)`}
      minHeight={0}
      minWidth={0}
      width="100%"
      height="100%"
      id={`cam-grid-${uniqueKey}`}
    >
      <For each={cameras}>
        {(camera, index) => {
          return (
            <GridItem key={`${uniqueKey}-${index}`} minHeight={0} minWidth={0} onDoubleClick={onPlayerDoubleClick}>
              <PerimeterCameraWrapper name={camera.name} position={camera.coordinates}>
                <Player
                  id={`player-${uniqueKey}-${index}`}
                  src={computePlayerStreamUrl(camera)}
                  playerType={camera.playerType}
                />
              </PerimeterCameraWrapper>
            </GridItem>
          );
        }}
      </For>
    </Grid>
  );
}

export default memo(CamGrid);
